import { flg } from "@aix/webutils/src/ui/logging"
import { AixContentBody, AixContentHeader } from "@aix/ui"
import { createFileRoute } from "@tanstack/react-router"

import {
  CaptionEditorProvider,
  CaptionEditorPanel,
  CaptionGeneratorCanvas,
  CaptionsBreadcrumb,
} from "~/components/CaptionGenerator"
import CustomHead from "~/components/SEOHead/CustomHead"

function CaptionEditorPage() {
  const { videoId } = Route.useParams()

  flg.debug("[CaptionEditorPage] Rendering with videoId:")

  return (
    <>
      <CustomHead title="Edit Captions | VidMax" description="Edit captions for your video" />

      <AixContentHeader className="flex-col w-full border-b">
        <CaptionsBreadcrumb currentPage="Edit Captions" />
      </AixContentHeader>

      <AixContentBody className="w-full p-0">
        <CaptionEditorProvider videoId={videoId}>
          <div className="flex h-[calc(100vh-120px)]">
            {/* Left Panel: Editor */}
            <div className="w-96 border-r bg-background overflow-hidden flex flex-col">
              <CaptionEditorPanel />
            </div>

            {/* Right Panel: Preview */}
            <div className="flex-1 p-4 bg-muted/20">
              <CaptionGeneratorCanvas className="h-full" />
            </div>
          </div>
        </CaptionEditorProvider>
      </AixContentBody>
    </>
  )
}

// Note: This route is rendered inside the parent's <Outlet />,
// which is already wrapped with AppLayout, so we don't wrap again
export const Route = createFileRoute("/create/captions/$videoId" as any)({
  component: CaptionEditorPage,
})
